import * as types from './mutation-types';
import API from '@/services/commonApi';
import { RMCUSTOMERS, RMBROKERS, RMPROJECTS, GETRM, RELEASEUNIT, SENDPAYMENTLINK, RMLIVE, DRMBROKERS } from '@/utils/endpoint';

const actions = {
  getRmLiveDetails: ({ commit }, auctionId) => {
    API.get(`${RMLIVE}${auctionId}/`)
      .then((response) => {
        commit(types.RMLIVEDETAILS, response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getMyCustomers: ({ commit }) => {
    API.get(RMCUSTOMERS)
      .then((response) => {
        commit(types.MYCUSTOMERS, response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getMyBrokers: ({ commit }) => {
    API.get(RMBROKERS)
      .then((response) => {
        commit(types.MYBROKERS, response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getMyProjects: ({ commit }) => {
    API.get(RMPROJECTS)
      .then((response) => {
        commit(types.MYPROJECTS, response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getDrmBrokers: ({ commit }) => {
    API.get(DRMBROKERS)
      .then((response) => {
        commit(types.DRMBROKERS, response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getRM: ({ commit }, payload) => {
    API.get(`${GETRM}${payload.id}/`)
      .then((response) => {
        console.log('RMs ->', response);
        commit(types.GETRM, response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  sendPaymentLink: ({ commit }, payload) => {
    API.post(SENDPAYMENTLINK, payload)
      .then((response) => {
        console.log('Payment link response ->', response, commit);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  releaseUnit: ({ commit }, payload) => {
    API.post(`${RELEASEUNIT}${payload.bidId}${'/'}`)
      .then((response) => {
        console.log('RMs ->', response, commit);
        if (payload && payload.cbSuccess)
          payload.cbSuccess(response);
      })
      .catch((error) => {
        console.log(error);
        if (payload && payload.cbSuccess)
          payload.cbError(error.message || error.detail);
      });
  },
  updateRmLive: ({ commit }, payload) => {
    commit(types.UPDATERMLIVEDETAILS, payload);
  },
  updateRmBroker: ({ commit }, payload) => {
    commit(types.UPDATERMBROKER, payload);
  },
  updateRmCustomer: ({ commit }, payload) => {
    commit(types.UPDATERMCUSTOMER, payload);
  },
  updateRmProject: ({ commit }, payload) => {
    commit(types.UPDATERMPROJECT, payload);
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/rm/actions.js